import React, { Dispatch, SetStateAction } from "react";
import "./css/index.css";
import Screen from "./Screen/Screen";
import { ReactComponent as ScrapSvg } from "./svg/scrap.svg";
type Props = {
  isLook: boolean;
  data: any;
  Cancel: Dispatch<SetStateAction<boolean>>;
};

const LookMagazine = ({ isLook, data, Cancel }: Props) => {
  return isLook ? (
    <div className="look-project-section">
      <button
        className="cancel-btn"
        onClick={() => {
          Cancel(false);
        }}
      >
        <img src="/assets/common/cancel.svg" alt="" />
      </button>
      <div className="magazine-look">
        <div className="leader-section">
          <div className="black-back" />
          <div className="wrapper">
            <div
              className="img-wrapper"
              style={{
                backgroundImage: `url(${data.mainimg})`,
              }}
            />
            <div className="title-section">
              <div className="title">{data.title}</div>
              <div className="position">
                {data.ctts_ctg_cd === "MGN_01"
                  ? `월간 팀플리더 | ${
                      data.leader.name ? data.leader.name : ""
                    }`
                  : data.category === "MGN_02"
                  ? "팀플러 인터뷰"
                  : "워크 스토리"}
              </div>
              <div className="sub">{data.leader.sub}</div>
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          <Screen data={data.template} />
          <a className="leader-project-btn" href={data.link}>
            <div className="left">
              <img
                src="/assets/popup/marketing.png"
                srcSet="/assets/popup/marketing@2x.png 2x , /assets/popup/marketing@3x.png 3x"
                alt=""
              />
              <div className="btn-title-section">
                <div className="sub">
                  지금 인터뷰 속 팀플리더를 만나보고 싶다면?
                </div>
                <div className="title">팀플 프로젝트 및 밋업 신청</div>
              </div>
            </div>
            <img
              src="/assets/common/black-arrow.svg"
              alt=""
              className="right"
            />
          </a>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default LookMagazine;
